import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=4fc59d48&scoped=true"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"
import style0 from "./Item.vue?vue&type=style&index=0&id=4fc59d48&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc59d48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fc59d48')) {
      api.createRecord('4fc59d48', component.options)
    } else {
      api.reload('4fc59d48', component.options)
    }
    module.hot.accept("./Item.vue?vue&type=template&id=4fc59d48&scoped=true", function () {
      api.rerender('4fc59d48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/deliveryNotes/Item.vue"
export default component.exports